<script setup>
import CalendarDay from './CalendarDay.vue';

defineProps({
	monthLabel: { type: String, required: true },
	year: { type: Number, required: true },
	weekdays: { type: Array, required: true },
	weekRows: { type: Array, required: true }
});

const emit = defineEmits(['day-click']);
</script>

<template>
  <div class="Calendar">
    <!-- Weekday headers (repeated per month, matching original markup) -->

    <div class="Calendar__month">
      <span>{{ monthLabel }} {{ year }}</span>
    </div>
    <div class="Calendar__days">
      <span v-for="day in weekdays" :key="day">{{ day }}</span>
    </div>

    <div
      v-for="week in weekRows"
      :key="week.weekNo"
      class="Calendar__row"
    >
      <CalendarDay
        v-for="dayData in week.days"
        :key="dayData.dateISO"
        :day="dayData"
      />
    </div>
  </div>
</template>
